import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';

import { AuthService } from '../../../../providers/auth.service';
import { PackageStateService } from '../upgrade-or-downgrade/store/package-state.service';
import { SubscriptionState } from './store/subscription-state';
import { SubscriptionStateService } from './store/subscription-state.service';
import { SharedClientService } from '../../shared/services/shared-client.service';
import { NotificationService } from '../../../shared/notification/notification.service';
import { BillingStateService } from '../store/billing-state.service';
import { default as swal } from 'sweetalert2';
import { BillingState } from '../store/billing-state';
import { Bill } from './store/bill';
import { URLSearchParams } from '@angular/http';


export class SubscriptionComponent implements OnInit, OnDestroy {
	public state: SubscriptionState;
	public billingState: BillingState;

	public customer: any;

	private unsubscribe$ = new Subject();
	private shouldNotReloaded: boolean;

	constructor(
		private authService: AuthService,
		private sharedClientService: SharedClientService,
		private billingStateService: BillingStateService,
		private subscriptionStateService: SubscriptionStateService,
		private packageStateService: PackageStateService,
		private modal: Modal,
		private notificationService: NotificationService) { }

	public ngOnInit(): void {
		this.subscribeToBillingState();
		this.subscribeToState();
		this.subscribeToPackages();

		this.getCurrentBilling();
	}

	public ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	public cancelSubscriptionClick(event) {
		event.preventDefault();
		if (this.billingState.actionInProgress) {
			return;
		}

		swal({
			title: `We're sorry to see you go`,
			text: 'Are you sure you want to cancel your subscription?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#E06160',
			cancelButtonColor: '#008fb3',
			confirmButtonText: 'Yes',
			cancelButtonText: 'No',
			allowOutsideClick: false,
			allowEscapeKey: false,
			reverseButtons: true
		}).then(() => {
			if (this.state.currentBilling.is_refund_possible) {
				let data = {
					send_to: 'customer-success-manager',
					message: 'This client has requested a refund during their money back guarantee period - please contact to confirm.',
					token: ''
				};

				this.sharedClientService.sendOwnerMessage(String(this.authService.userId), data).subscribe(
					(resp) => {
						this.afterCancelAccountDone();
					}
				);
			} else {
				this.subscriptionStateService.setLoading(true);
				this.billingStateService.setActionInProgress(true);
				this.sharedClientService.cancelAccount(String(this.authService.userId)).subscribe(
					() => {
						this.afterCancelAccountDone();
						this.shouldNotReloaded = true;
						this.getCurrentBilling(true);
						this.notificationService.emitEventAction({action: 'reload-notifications'});
						this.sharedClientService.emitEventAction('reloadClientPermissions');
						this.billingStateService.setActionInProgress(false);
					}
				);
			}
		}, () => undefined);
	}

	public saveBillingInformation(validForm: boolean): void {
		if (!validForm) {
			return;
		}
		this.subscriptionStateService.setLoading(true);
		let data = {
			email: this.customer.email
		};
		this.sharedClientService.updateCustomerBillingInfo(String(this.authService.userId), data).subscribe(
			() => {
				this.getStripeCustomer();
			},
			() => {
				this.subscriptionStateService.setLoading(false);
			}
		);
	}

	public reloadData(): void {
		this.subscriptionStateService.resetFirstLoad();
		this.getCurrentBilling();
	}

	private afterCancelAccountDone() {
		swal({
			title: '',
			html: `We have received your cancellation request and it is being processed. Your Account Manager will be in touch to let you know when it's complete.`,
			type: 'success',
			showCancelButton: false,
			confirmButtonColor: '#008fb3',
			confirmButtonText: 'Close',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
	}

	private subscribeToState() {
		this.subscriptionStateService.state$.takeUntil(this.unsubscribe$).subscribe(
			(state) => {
				this.state = state;
			}
		);
	}

	private subscribeToBillingState() {
		this.billingStateService.state$.takeUntil(this.unsubscribe$).subscribe(
			(state) => {
				this.billingState = state;
			}
		);
	}

	private getCurrentBilling(isLoading = false): void {
		if (!isLoading) {
			this.subscriptionStateService.setLoading(true);
		}
		let queryParams = new URLSearchParams();
		queryParams.set('include_prices', '1');
		this.sharedClientService.getCurrentBilling(String(this.authService.userId), queryParams).subscribe(
			(currentBilling) => {
				this.subscriptionStateService.setCurrentBilling(this.orderProducts(currentBilling));

				this.getUpcomingBilling();

				if (currentBilling.type === 'package') {
					this.getCurrentBillingPackageTemplate();
				}
			},
			() => {
				this.subscriptionStateService.setCurrentBilling(null);
				this.getUpcomingBilling();
			}
		);
	}

	private getUpcomingBilling(): void {
		this.sharedClientService.getUpcomingBilling(String(this.authService.userId)).subscribe(
			(upcomingBilling) => {
				this.subscriptionStateService.setUpcomingBilling(this.orderProducts(upcomingBilling));
				this.getStripeCustomer();
			},
			() => {
				this.subscriptionStateService.setUpcomingBilling(null);
				this.getStripeCustomer();
			}
		);
	}

	private getCurrentBillingPackageTemplate() {
		this.sharedClientService.getClientBillingPackageTemplate(String(this.authService.userId), this.state.currentBilling.package.client_package_template_id).subscribe(
			(template) => {
				this.subscriptionStateService.setCurrentBillingPackageTemplate(template);
			},
			() => {
				this.subscriptionStateService.setCurrentBillingPackageTemplate(null);
			}
		);
	}

	private subscribeToPackages() {
		this.packageStateService.state$.takeUntil(this.unsubscribe$).subscribe(
			(packageState) => {
				if (packageState.firstLoad && !packageState.loading) {
					if (!this.shouldNotReloaded) {
						this.getCurrentBilling();
					} else {
						this.shouldNotReloaded = false;
					}
				}
			}
		);
	}

	private orderProducts(bill: Bill): Bill {
		if (bill && bill.package && bill.package.products && bill.package.products.length) {
			bill.package.products.sort((a, b) => {
				if (a.identifier === 'interview-requests') {
					return -1;
				} else if (b.identifier === 'interview-requests') {
					return 1;
				}
				return 0;
			});
		}
		return bill;
	}

	private getStripeCustomer(): void {
		let previousCustomerState = this.customer;
		this.subscriptionStateService.setLoading(true);
		this.sharedClientService.getStripeCustomer(String(this.authService.userId)).subscribe(
			(customer) => {
				this.customer = customer;
				this.subscriptionStateService.setLoading(false);
			},
			() => {
				this.customer = previousCustomerState;
				this.subscriptionStateService.setLoading(false);
			}
		);
	}
static ctorParameters() { return [ { type: AuthService }, { type: SharedClientService }, { type: BillingStateService }, { type: SubscriptionStateService }, { type: PackageStateService }, { type: Modal }, { type: NotificationService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/billing/subscription/subscription.component.ts